import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IEarlyReturnRouteParams {
    reservationId: Guid
}

interface IEarlyReturnRouteQuery {
    end: string
}

const EarlyReturnRoute = new AppRoute<IEarlyReturnRouteParams, IEarlyReturnRouteQuery>({
    route: "/early-return/:reservationId",
    navbar: true,
    authRequired: true,
    minWidth: "auto",
})

export default EarlyReturnRoute
